import axiosInstance from '@/services/axiosInstance'

async function findUser (membership) {
  const data = {
    filter: [{
      Field: 'NumSocio',
      Criteria: membership
    }]
  }
  const req = {
    url: '/rgcc-services/ListaSocios/ReadMultiple',
    method: 'POST',
    data
  }

  const res = await axiosInstance(req)

  const users = res.data?.ReadMultiple_Result?.ListaSocios
  return users?.length ? users[0] : null
}

async function findUserByInternalNumber (internalNumber) {
  const data = {
    filter: [{
      Field: 'No',
      Criteria: internalNumber
    }]
  }
  const req = {
    url: '/rgcc-services/ListaSocios/ReadMultiple',
    method: 'POST',
    data
  }

  const res = await axiosInstance(req)

  return res.data
}

export {
  findUser,
  findUserByInternalNumber
}
